import { useLocation, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function ScannerIcon({ active }) {
  return (
    <svg
      className={`h-6 w-6 ${active ? 'text-primary' : 'text-faint'}`}
      fill={active ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={active ? 0 : 1.5}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {active ? (
        <>
          <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2zm16 0v10H5V7h14z" />
          <rect x="7" y="9" width="10" height="6" rx="1" />
          <path d="M9 3H5a2 2 0 00-2 2v2" />
          <path d="M15 3h4a2 2 0 012 2v2" />
          <path d="M9 21H5a2 2 0 01-2-2v-2" />
          <path d="M15 21h4a2 2 0 002-2v-2" />
        </>
      ) : (
        <>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7 9h10v6H7z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 3H5a2 2 0 00-2 2v2"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 3h4a2 2 0 012 2v2"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 21H5a2 2 0 01-2-2v-2"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 21h4a2 2 0 002-2v-2"
          />
        </>
      )}
    </svg>
  )
}

function SettingsIcon({ active }) {
  return (
    <svg
      className={`h-6 w-6 ${active ? 'text-primary' : 'text-faint'}`}
      fill={active ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={active ? 0 : 1.5}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {active ? (
        <path d="M19.14 12.94a7.07 7.07 0 00.06-.94c0-.32-.02-.64-.06-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.48.48 0 00-.59-.22l-2.39.96a6.93 6.93 0 00-1.62-.94l-.36-2.54a.48.48 0 00-.48-.41h-3.84a.48.48 0 00-.48.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.48.48 0 00-.59.22L2.74 8.87a.48.48 0 00.12.61l2.03 1.58c-.04.3-.06.62-.06.94s.02.64.06.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.37 1.03.7 1.62.94l.36 2.54c.05.24.26.41.48.41h3.84c.22 0 .43-.17.48-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.49.49 0 00-.12-.61l-2.03-1.58zM12 15.6A3.6 3.6 0 1115.6 12 3.6 3.6 0 0112 15.6z" />
      ) : (
        <>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 15.6a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.14 12.94c.04-.3.06-.62.06-.94 0-.32-.02-.64-.06-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.48.48 0 00-.59-.22l-2.39.96a6.93 6.93 0 00-1.62-.94l-.36-2.54a.48.48 0 00-.48-.41h-3.84a.48.48 0 00-.48.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.48.48 0 00-.59.22L2.74 8.87a.48.48 0 00.12.61l2.03 1.58c-.04.3-.06.62-.06.94s.02.64.06.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.37 1.03.7 1.62.94l.36 2.54c.05.24.26.41.48.41h3.84c.22 0 .43-.17.48-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.49.49 0 00-.12-.61l-2.03-1.58z"
          />
        </>
      )}
    </svg>
  )
}

export default function BottomNav() {
  const location = useLocation()
  const { t } = useTranslation()

  const isScanner =
    location.pathname === '/' || location.pathname.startsWith('/results/')
  const isSettings = location.pathname === '/settings'

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-line bg-surface"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      aria-label={t('nav.main')}
    >
      <div className="flex h-14 items-stretch">
        <Link
          to="/"
          className={`flex flex-1 flex-col items-center justify-center gap-0.5 text-xs font-medium min-h-[48px] transition-colors ${
            isScanner
              ? 'text-primary'
              : 'text-faint hover:text-muted'
          }`}
          aria-current={isScanner ? 'page' : undefined}
        >
          <ScannerIcon active={isScanner} />
          <span>{t('nav.scanner')}</span>
        </Link>
        <Link
          to="/settings"
          className={`flex flex-1 flex-col items-center justify-center gap-0.5 text-xs font-medium min-h-[48px] transition-colors ${
            isSettings
              ? 'text-primary'
              : 'text-faint hover:text-muted'
          }`}
          aria-current={isSettings ? 'page' : undefined}
        >
          <SettingsIcon active={isSettings} />
          <span>{t('nav.settings')}</span>
        </Link>
      </div>
    </nav>
  )
}
